import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import gql from 'graphql-tag';

import { saveState } from '../../utils/localStorage';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { loggedIn: false };
  }

  async componentDidMount() {
    const { client, token } = this.props;
    await this.saveLoginState();
    await this.handleLogin();
    /* eslint-disable react/no-did-mount-set-state */
    await this.setState({ loggedIn: true }, () => client.mutate({ mutation: NILIFY_TOKEN, variables: { token } }));
  }

  handleLogin = () => {
    const { authenticationToken, firstName, lastName, uberProfileImageUrl, operatingCity, login } = this.props;
    /* eslint-disable react/no-did-mount-set-state */
    login({
      ...this.props,
      first_name: firstName,
      last_name: lastName,
      uber_profile_image: { url: uberProfileImageUrl },
      operating_city: operatingCity,
      authentication_token: authenticationToken,
    });
  };

  saveLoginState = () => {
    const { authenticationToken, firstName, lastName, uberProfileImageUrl, operatingCity } = this.props;
    saveState({
      auth: {
        token: authenticationToken,
        firstName,
        lastName,
        profileImage: uberProfileImageUrl,
        operatingCity,
      },
    });
  };
  render() {
    return this.state.loggedIn ? <Redirect to="/dashboard" /> : null;
  }
}

export default withApollo(Login);

const NILIFY_TOKEN = gql`
  mutation nilifyToken($token: String!) {
    nilifyToken(token: $token) {
      success
      errors {
        message
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/User/MagicLoginSucess.js